
<ion-toolbar >
 
  <ion-buttons slot="end">
    <ion-button (click)="closeModal()"
      ><ion-icon color="dark" name="close"></ion-icon
    ></ion-button>
  </ion-buttons>

  
</ion-toolbar>
<ion-content class="pages_card_background">
  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
  <ion-card class="single-col-wider">
    <ion-grid *ngIf="loaded">
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular" >{{('keys.data.lockers.locker_information' | translate : {Default:'Locker Information'}) || 'Locker Information'}}</h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <ion-label  class="card-text-regular">
            {{
              lockerArea.area.Location
            }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <ion-label  class="card-text-regular">
            {{ lockerArea.area.AreaDescr }}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center">
          <ion-chip style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;">
            {{ ('keys.data.permits.sale_window' | translate : {Default:'Sale Window'}) ||
              'Sale Window' }} {{
                lockerArea['lockerWindowTypes'][
                  lockerArea.area.AreaLockerType
                ]
              }}</ion-chip>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-item lines="none" class="paragraph-input-fields-regular">
            <ion-label >
              {{('keys.data.permits.start_date' | translate : {Default:'Start Date'}) || 'Start Date'}}
            </ion-label>
            <span 
            class="ion-text-wrap"
            style="text-align: right"
              >
              {{lockerArea?.area?.SemStart | date:dataService.settings['system']['datemask']}}
            </span>
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-item lines="none" class="paragraph-input-fields-regular">
            <ion-label >
              {{('keys.data.permits.end_date' | translate : {Default:'End Date'}) || 'End Date'}}
            </ion-label>
            <span 
            class="ion-text-wrap"
            style="text-align: right"
              >
              {{lockerArea?.area?.SemEnd | date:dataService.settings['system']['datemask']}}
            </span>
          </ion-item>
        </ion-col>
      </ion-row>
        <ion-row>
          <ion-col>
            <ion-item lines="none" class="paragraph-input-fields-regular">
              <ion-label >
                {{('keys.data.permits.rental_cost' | translate : {Default:'Rental Cost'}) || 'Rental Cost'}}
              </ion-label>
              <p slot="end">
                {{
                  lockerArea.dollarvalues.item_price | currency
                }}
              </p>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item lines="none" class="paragraph-input-fields-regular">
              <ion-label >
                {{('keys.data.common.subtotal' | translate : {Default:'Subtotal'}) || 'Subtotal'}}
                    
              </ion-label>
              <p slot="end">
                {{
                  lockerArea.dollarvalues.subtotal | currency
                }}
              </p>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row *ngFor="let tax of lockerArea?.totals?.taxes">
          <ion-col>
            <ion-item lines="none" class="paragraph-input-fields-regular">
              <ion-label>
                {{ tax?.label  }} {{ tax?.percentage | round:3 }}%
              </ion-label>
              <span style="text-align: right">
                {{ tax?.amount|
                  currency}}
              </span>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item lines="none" class="paragraph-bold">
              <ion-label >
                {{('keys.data.common.total_owing' | translate : {Default:'Total Owing'}) || 'Total Owing'}}
              </ion-label>
              <p slot="end">
                {{
                  lockerArea.dollarvalues.total | currency
                }}
              </p>
            </ion-item>
          </ion-col>
        </ion-row>
    </ion-grid>
  </ion-card>
  
    <ion-grid *ngIf="loaded"  class="single-col-wider">
      <ion-row >
        <ion-col>
          <ion-card class="card-shadow-3">
          <ion-item lines="none">
            <ion-label>{{('keys.data.lockers.locker_number' | translate : {Default:'Locker Number'}) || 'Locker Number'}}:</ion-label>
            <ion-select #lockerId multiple="false" interface="popover">
              <ion-select-option
                *ngFor="let v of lockerArea['lockers']"
                [value]="v.LockerID"
                >{{ v.LockerNum }}</ion-select-option
              >
            </ion-select>
          </ion-item>
        </ion-card>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="
      lockerArea['otherLockers'] <=
        dataService.settings.lockers.maxPerUser;">
        <ion-col>
          <ion-button expand="block"
            color="primary"
            (click)="onReserveLocker(lockerId.value)"
            [disabled]="!lockerId.value"
          >
          {{('keys.data.lockers.reserve_locker' | translate : {Default:'Reserve Locker'}) || 'Reserve Locker'}}
          </ion-button>
          </ion-col>
      </ion-row>
      <ion-row  *ngIf="
      lockerArea['otherLockers'] >
        dataService.settings.lockers.maxPerUser;">
        <ion-col>
          <ion-card class="alert-warning ion-padding ion-text-wrap"
                ><ion-text>
                  {{('keys.data.lockers.max_lockers_reached' | translate : {Default:'You have reached the maximum number of locker reservations.'}) || 'You have reached the maximum number of locker reservations.'}}
                </ion-text>
              </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  
</ion-content>
